module.exports = __webpack_public_path__ + "milan-3b40653ea1282b30349dae090377b7b5.bundle.jpg";